import { render } from "./SFSCheckbox.vue?vue&type=template&id=47a659ac&ts=true"
import script from "./SFSCheckbox.vue?vue&type=script&lang=ts"
export * from "./SFSCheckbox.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sfs-projects/development/station-handler-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__